<template>
  <div class="container py-4">
    <div class="page-card">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h4 class="mb-0">Suppliers</h4>
        <icon-button
          :func="() => openCreate()"
          :icon="'plus'"
          :title="'Add supplier'"
          :classes="'akkurate-green-btn btn-size2'"
          :btnName="'Add supplier'"
        />
      </div>

      <b-form-input
        v-model="search"
        class="mb-3 form-control"
        placeholder="Search suppliers..."
        @input="debouncedLoad"
      />

      <b-table
        :items="suppliers"
        :fields="fields"
        :busy="loading"
        responsive
        hover
        small
      >
        <template #cell(isActive)="data">
          <b-badge
            :variant="data.value ? 'success' : 'secondary'"
            :class="statusBadge(data.value)"
          >
            {{ data.value ? "Active" : "Inactive" }}
          </b-badge>
        </template>
        <template #cell(actions)="data">
          <!-- <b-button size="sm" variant="link" @click="openEdit(data.item)"
            >Edit</b-button
          > -->
          <!-- IconButton -->
          <icon-button
            :func="() => openEdit(data.item)"
            :icon="'eye'"
            :title="'Edit'"
            :classes="'akkurate-warning btn-sm'"
            :btnName="''"
          />
        </template>
      </b-table>
    </div>

    <b-modal
      v-model="showForm"
      :title="editingId ? 'Edit supplier' : 'New supplier'"
      @ok="save"
    >
      <b-form-group label="Name">
        <b-form-input class="form-control" v-model="form.name" required />
      </b-form-group>
      <b-form-group label="Code">
        <b-form-input class="form-control" v-model="form.code" />
      </b-form-group>
      <b-form-group label="Contact name">
        <b-form-input class="form-control" v-model="form.contactName" />
      </b-form-group>
      <b-form-group label="Email">
        <b-form-input class="form-control" v-model="form.email" type="email" />
      </b-form-group>
      <b-form-group label="Phone">
        <b-form-input class="form-control" v-model="form.phone" />
      </b-form-group>
      <b-form-group label="Address">
        <b-form-textarea v-model="form.address" rows="2" />
      </b-form-group>
      <b-form-group label="Payment terms">
        <b-form-input
          class="form-control"
          v-model="form.paymentTerms"
          placeholder="e.g. Net 30"
        />
      </b-form-group>

      <template #modal-footer="{ ok, cancel }">
        <icon-button
          :func="() => cancel()"
          :icon="'times'"
          :title="''"
          :classes="'akkurate-danger-bg btn-size2'"
          :btnName="'Close'"
        />
        <icon-button
          :func="() => ok()"
          :icon="'check'"
          :title="''"
          :classes="'akkurate-green-btn btn-size2'"
          :btnName="'Save'"
        />
      </template>
    </b-modal>
  </div>
</template>

<script>
import ApiService from "@/core/services/api.service";
import IconButton from "@/components/IconButton.vue";

export default {
  name: "Suppliers",
  components: {
    IconButton,
  },
  data() {
    return {
      suppliers: [],
      loading: false,
      search: "",
      searchTimer: null,
      showForm: false,
      editingId: null,
      form: {
        name: "",
        code: "",
        contactName: "",
        email: "",
        phone: "",
        address: "",
        paymentTerms: "",
      },
      fields: [
        { key: "code", label: "Code" },
        { key: "name", label: "Name" },
        { key: "contactName", label: "Contact" },
        { key: "phone", label: "Phone" },
        { key: "paymentTerms", label: "Terms" },
        { key: "isActive", label: "Status" },
        { key: "actions", label: "Actions" },
      ],
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    debouncedLoad() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(this.load, 300);
    },
    async load() {
      this.loading = true;
      try {
        const params = {};
        if (this.search.trim()) params.query = this.search.trim();
        this.suppliers = await ApiService.get("suppliers", params);
      } finally {
        this.loading = false;
      }
    },
    openCreate() {
      this.editingId = null;
      this.form = {
        name: "",
        code: "",
        contactName: "",
        email: "",
        phone: "",
        address: "",
        paymentTerms: "",
      };
      this.showForm = true;
    },
    openEdit(item) {
      this.editingId = item.id;
      this.form = {
        name: item.name,
        code: item.code || "",
        contactName: item.contactName || "",
        email: item.email || "",
        phone: item.phone || "",
        address: item.address || "",
        paymentTerms: item.paymentTerms || "",
      };
      this.showForm = true;
    },
    async save(bvModalEvt) {
      bvModalEvt.preventDefault();
      try {
        if (this.editingId) {
          await ApiService.put(`suppliers/${this.editingId}`, this.form);
        } else {
          await ApiService.post("suppliers", this.form);
        }
        this.showForm = false;
        await this.load();
        toast.fire({
          title: "Supplier saved",
          icon: "success",
        });
      } catch (e) {
        toast.fire({
          title: e?.response?.data?.message || "Save failed",
          icon: "danger",
        });
      }
    },
  },
};
</script>
